import React from 'react';
import styled from 'styled-components';
import InputLabel from '@material-ui/core/InputLabel';
import { InfoText } from '../InfoText/InfoText';

interface Props {
  text?: string;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
  dataTest: string;
  htmlFor?: string;
  infoText?: string;
  className?: string;
}

export const Label: React.FC<React.PropsWithChildren<Props>> = ({
  required,
  text,
  infoText,
  dataTest,
  htmlFor,
  error,
  className,
  disabled = false
}) => {
  if (!text) {
    return null;
  }
  return (
    <StyledLabelContainer className={`label ${className}`}>
      <InputLabel
        required={required}
        shrink
        error={error}
        data-test={`${dataTest}-field-label`}
        htmlFor={htmlFor}
        disabled={disabled}
      >
        <InfoText label={text} required={required} tooltipText={infoText} />
      </InputLabel>
    </StyledLabelContainer>
  );
};

const StyledLabelContainer = styled.div`
  margin-top: -2px;
  margin-bottom: 8px;
`;
